import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import _ from 'lodash'
import axios from 'axios'
import { message } from 'antd'
import FileSaver from 'file-saver'

const service = new ApolloClientService()

export default class Surgeon {
  getSurgeonList = (customerid) => {
    return new Promise((resolve, reject) => {
      service
        .getSurgeonList({ customerid })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            data.message = data.status
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getSurgeons = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getSurgeons(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getAccessCode = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getAccessCode(params)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => console.log(err))
    })
  }

  onSurgeonSelect = ({ surgeons, surgeon, flag }) => {
    var selectedSurgeons = JSON.parse(JSON.stringify(surgeons))
    flag
      ? selectedSurgeons.push(surgeon)
      : _.remove(selectedSurgeons, (surg) => surg._id == surgeon._id)
    return selectedSurgeons
  }

  addEditSurgeon = (params, id) => {
    return new Promise((resolve, reject) => {
      service
        .addEditSurgeon(params, id)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  removeSurgeons = (params) => {
    return new Promise((resolve, reject) => {
      service
        .removeSurgeons(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getSurgeon = (id) => {
    return new Promise((resolve, reject) => {
      service
        .getSurgeon(id)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getVcf = (id, filename, download = true) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.API_URL}/vcf/${id}?role=${constants.ROLE.SURGEON}`, {
          responseType: 'blob',
        })
        .then((response) => {
          console.log(response.data)
          if (download) {
            // navigator.msSaveBlob(response.data, filename)
            // new Blob(response.data, {type: "text/vcard"})
            // .arrayBuffer()
            // .then((arraybuffer) => {
            // FileSaver.saveAs(response.data.slice(0, response.data.size, "text/vcard"), filename );
            //     })
            var reader = new FileReader()
            var out = response.data
            reader.onload = function (e) {
              window.location.href = reader.result
            }
            reader.readAsDataURL(out)

            // var blob = new Blob([response.data], { type: "application/pdf" });
            // var fileURL = URL.createObjectURL(out);
            // var a = document.createElement('a');
            // a.href = fileURL;
            // a.target = '_blank';
            // a.download = filename;
            // document.body.appendChild(a);
            // a.click();
          }
          resolve(response.data)
        })
        .catch((err) => {
          console.log(err)
          message.info('Something went wrong. Please try again.')
          resolve(err)
        })
    })
  }

  getSurgeonImage = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getSurgeonImage(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            message.error(data.message)
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
}
